import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import Index from './views/Index.vue'
import Home from './views/Home.vue'
import Service from './views/Service.vue'
import ServiceDetails from './views/Service_details.vue'
import orders_tk from './views/orders_tk/orders_tk.vue'
import orders_tk_details from './views/orders_tk/details.vue'
import Account from './views/Account.vue'
import Connection from './views/Connection.vue'
import Login from './views/Login.vue'
import Orders from './views/orders'
import orders_ from './views/orders_'
import orders_foster from './views/orders_foster'
import orders_foster_records from './views/orders_foster_records'
import orders_boarding from './views/orders_boarding'
import OrdersBoardingDetail from './views/orders_boarding/detail.vue'
import OrdersDetail from './views/orders/detail'
import NurseManagement from './views/nurse-management/index'
import NursingStationManagement from './views/nursing-station-management/index'
import NursingStationEdit from './views/nursing-station-management/edit.vue'
import Hospital from './views/hospital/index'
import DiscountManagement from './views/discount/index'
import DiscountDetail from './views/discount/detail'
import Financial from './views/financial/index'
import NotFound from './views/NotFound.vue'
import Statistics from './views/statistics'
import OrdersSn from './views/orders_sn/index.vue'
import OrdersSnDetail from './views/orders_sn/detail.vue'
import OrdersTf from './views/orders_tf/index.vue'
import OrdersTfDetail from './views/orders_tf/detail.vue'
import { hasScreenPermission, isAdmin } from './utils/util'

Vue.use(Router)

const SmartScreen = () => import('./views/screen/index.vue')

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? '/' : '/manage',
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/screen',
      name: 'SmartScreen',
      component: SmartScreen
    },
    {
      path: '/',
      component: Index,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home
        },
        {
          path: '/service',
          name: 'service',
          component: Service
        },
        {
          path: '/details',
          name: 'details',
          component: ServiceDetails
        },
        {
          path: '/account',
          name: 'account',
          component: Account
        },
        {
          path: '/connection',
          name: 'connection',
          component: Connection
        },
        {
          path: '/orders',
          name: 'orders',
          component: Orders
        },
        {
          path: '/orders_',
          name: 'orders_',
          component: orders_
        },
        {
          path: '/orders_tk',
          name: 'orders_tk',
          component: orders_tk
        },
        {
          path: '/orders_tk_details',
          name: 'orders_tk_details',
          component: orders_tk_details
        },
        {
          path: '/orders_foster',
          name: 'orders_foster',
          component: orders_foster
        },
        {
          path: '/orders_foster_records',
          name: 'orders_foster_records',
          component: orders_foster_records
        },
        {
          path: '/orders_boarding',
          name: 'orders_boarding',
          component: orders_boarding
        },
        {
          path: '/orders_boarding_detail',
          name: 'orders_boarding_detail',
          component: OrdersBoardingDetail
        },
        {
          path: '/orders_sn',
          name: 'orders_sn',
          component: OrdersSn
        },
        {
          path: '/orders_sn_detail',
          name: 'orders_sn_detail',
          component: OrdersSnDetail
        },
        {
          path: '/orders_tf',
          name: 'orders_stf',
          component: OrdersTf
        },
        {
          path: '/orders_tf_detail',
          name: 'orders_tf_detail',
          component: OrdersTfDetail
        },
        {
          path: '/order-details',
          name: 'ordersDetail',
          component: OrdersDetail
        },
        {
          path: '/financial',
          name: 'financial',
          component: Financial
        },
        {
          path: '/statistics',
          name: 'Statistics',
          component: Statistics
        },
        {
          path: '/nurse-management',
          name: 'NurseManagement',
          component: NurseManagement
        },
        {
          path: '/nurse-station-management',
          name: 'NursingStationManagement',
          component: NursingStationManagement
        },
        {
          path: '/nurse-station-edit',
          name: 'NursingStationEdit',
          component: NursingStationEdit
        },
        {
          path: '/nurse-station-insert',
          name: 'NursingStationInsert',
          component: NursingStationEdit
        },
        {
          path: '/hospital-management',
          name: 'Hospital',
          component: Hospital
        },
        {
          path: '/discount-management',
          name: 'DiscountManagement',
          component: DiscountManagement
        },
        {
          path: '/discount-detail/:id',
          name: 'DiscountDetail',
          component: DiscountDetail
        },
        {
          path: '/404',
          component: NotFound
        }
      ]
    },
    {
      path: '*',
      redirect: { path: '/404' }
    }
  ]
})

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  const LOGINURL = '/login'

  const url = to.path
  const token = sessionStorage.getItem('AuthToken')
  const roles = store.state.rules

  if (url === LOGINURL) {
    sessionStorage.removeItem('AuthToken')
  }

  // 判断是否登录
  if (!token && url !== LOGINURL) {
    next({ path: LOGINURL })
  } else {
    if (!(roles && roles !== '' && roles.length)) {
      try {
        const raw = sessionStorage.getItem('role')
        store.commit('INIT_ROLES', raw ? JSON.parse(raw) : [])
      } catch (e) {
        store.commit('INIT_ROLES', [])
      }
    }
    if (url === '/account' && !isAdmin()) {
      next({ path: '/home' })
    } else if (url === '/screen' && !hasScreenPermission(store.state.rules)) {
      next({ path: '/home' })
    } else {
      next()
    }
  }
})

export default router
